"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trap = function trap(e) {
  return e.stopPropagation();
};

function EventTrap(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "event-trap",
    onClick: trap,
    onContextMenu: trap,
    onDoubleClick: trap,
    onDrag: trap,
    onDragEnd: trap,
    onDragEnter: trap,
    onDragExit: trap,
    onDragLeave: trap,
    onDragOver: trap,
    onDragStart: trap,
    onDrop: trap,
    onMouseDown: trap,
    onMouseEnter: trap,
    onMouseLeave: trap,
    onMouseMove: trap,
    onMouseOver: trap,
    onMouseOut: trap,
    onMouseUp: trap,
    onKeyDown: trap,
    onKeyPress: trap,
    onKeyUp: trap,
    onFocus: trap,
    onBlur: trap,
    onChange: trap,
    onInput: trap,
    onInvalid: trap,
    onSubmit: trap,
    onTouchCancel: trap,
    onTouchEnd: trap,
    onTouchMove: trap,
    onTouchStart: trap
  }, children);
}

EventTrap.propTypes = {
  children: _propTypes.default.node.isRequired
};
var _default = EventTrap;
exports.default = _default;